import type { DeepPartial } from '@luna/utils-ts';

import type { Statements } from '../../types/Statements';

export const statementsATFeatureConfig: DeepPartial<Statements> = {
    hasPaging: true,
    statementColumns: ['statementDate', 'title', 'subType', 'orderNumber', 'amount', 'actions'],
    supportedStatementTypes: ['PORTFOLIO'],
};
